angular.module('impactx.requestItem').directive('ixRequestItemStringAttributeLine', function ()
{
    return {
        scope: {
            attribute: "="
        },
        restrict: 'A',
        templateUrl: 'shared/requestitem/templates/requestitemattributeline.tmpl.html'
    };
});